import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Clearfix } from 'react-bootstrap';

import { getColor } from 'helpers/charts';
import { getNameInCurrentLanguage } from 'helpers/intl';

import IntlDateTime from 'components/layout/IntlDateTime';

import RichEditorContent from 'components/RichEditorContent';

class Lead extends React.Component {
  render() {
    const {
      intl: { messages },
      appIntl,
      appt,
    } = this.props;

    const color = '#' + getColor(appt.color || 1, 81);

    return (
      <div>
        <div className="event-inner">
          <div className="event-title">
            <Clearfix className="m-b-15">
              <div className="pull-left p-r-20">
                <Link to={appIntl.urlPrefix + 'account/leads/' + appt.id} style={{ color }}>
                  <span className="p-r-5">
                    <i class="fad fa-fw fa-circle" style={{ color }} />
                  </span>{' '}
                  <span className="bold" style={{ color }}>
                    {appt.name}
                  </span>
                </Link>
              </div>
              <div className="pull-right">
                <Link to={appIntl.urlPrefix + 'account/leads/' + appt.id} style={{ color }}>
                  <i className="far fa-external-link-alt" />
                </Link>
              </div>
            </Clearfix>
          </div>

          <Clearfix className="m-b-5">
            <div className="pull-left p-r-5">
              <i className="fal fa-fw fa-clock" />
            </div>
            <div className="pull-left">
              <IntlDateTime date={appt.date_from} />
            </div>
          </Clearfix>

          <Clearfix className="m-b-5">
            <div className="pull-left p-r-5">
              <i className="fal fa-fw fa-tasks" />
            </div>
            <div className="pull-left">
              {messages.pipeline}: {(appt.pipeline && getNameInCurrentLanguage(appt.pipeline.name, appIntl)) || '-'}
            </div>
          </Clearfix>

          <Clearfix className="m-b-5">
            <div className="pull-left p-r-5">
              <i className="fal fa-fw fa-align-left" />
            </div>
            <div className="pull-left">
              <RichEditorContent content={'<div>' + (appt.description || '') + '</div>'} />
            </div>
          </Clearfix>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(Lead));
